import { jsx as _jsx } from "react/jsx-runtime";
import classNames from 'classnames';
import { useContext } from 'react';
import { BookerContext } from '../Booker.js';
const FieldContainer = ({ className, children, clipMargin, noBorder, noPadding }) => {
    const { useTailwindPrefix, version, vertical, showLabels } = useContext(BookerContext);
    return (_jsx("div", Object.assign({ className: classNames('itm-booker-field-container', className, Object.assign({}, (!useTailwindPrefix
            ? Object.assign({ 'w-full text-[#565a5c] md:relative mb-3': true, 'md:-mr-px': clipMargin }, (version === 'padded' && !vertical
                ? {
                    'md:mb-0': !noPadding,
                    'md:border-l first:border-none last:border-none': !noBorder,
                    'md:flex-1 md:-mr-widget-pill-padding-x': noPadding,
                    'md:-my-widget-pill-padding-y': noPadding && !showLabels,
                    'md:-mt-widget-pill-padding-y md:-mb-widget-pill-padding-b': noPadding && showLabels,
                }
                : null)) : Object.assign({ 'tw-w-full tw-text-[#565a5c] md:tw-relative tw-mb-3': true, 'md:-tw-mr-px': clipMargin }, (version === 'padded' && !vertical
            ? {
                'md:tw-mb-0': !noPadding,
                'md:tw-border-l first:tw-border-none last:tw-border-none': !noBorder,
                'md:tw-flex-1 md:-tw-mr-widget-pill-padding-x': noPadding,
                'md:-tw-my-widget-pill-padding-y': noPadding && !showLabels,
                'md:-tw-mt-widget-pill-padding-y md:-tw-mb-widget-pill-padding-b': noPadding && showLabels,
            }
            : null))))) }, { children: children })));
};
export default FieldContainer;
